import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import { BrowserRouter as Router } from 'react-router-dom';

const run = () => {
  const defaultTheme = createTheme();
  const theme = responsiveFontSizes(createTheme({
    typography: {
      fontFamily: `"Euclid", "Helvetica", "Arial", sans-serif`,
    },
    palette: {
      zgdLightBlue: defaultTheme.palette.augmentColor({
        color: { main: '#C3E4EB' },
        name: 'zgdLightBlue'
      }),
      white: defaultTheme.palette.augmentColor({
        color: { main: '#FFFFFF' },
        name: 'white'
      })
    }
  }));

  ReactDOM.render(
    <React.StrictMode>
      <ThemeProvider theme={theme}>
        <Router>
          <App />
        </Router>
      </ThemeProvider>
    </React.StrictMode>,
    document.getElementById('root')
  );
};



run();

function sendToGoogleAnalytics({name, delta, value, id}: any) {
  // Assumes the global `gtag()` function exists, see:
  // https://developers.google.com/analytics/devguides/collection/ga4
  gtag('event', name, {
    // Built-in params:
    value: delta, // Use `delta` so the value can be summed.
    // Custom params:
    metric_id: id, // Needed to aggregate events.
    metric_value: value, // Optional.
    metric_delta: delta, // Optional.

    // OPTIONAL: any additional params or debug info here.
    // See: https://web.dev/debug-web-vitals-in-the-field/
    // metric_rating: 'good' | 'ni' | 'poor',
    // debug_info: '...',
    // ...
  });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(sendToGoogleAnalytics);